import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'side-panel',
  templateUrl: './side-panel.component.html',
  styleUrls: ['./side-panel.component.scss']
})
export class SidePanelComponent {
  isPanelActive = false;

  @Input() set openPanel(op: boolean) {
    this.isPanelActive = op;
  };
  @Output() panelClosed = new EventEmitter<boolean>();

  constructor() {
  }

  togglePanel(): void {
    this.isPanelActive = !this.isPanelActive;
    this.panelClosed.emit(this.isPanelActive);
  }
}
